import { useEffect } from 'react';
import { useSiteImage } from '@/hooks/useSiteImage';

// index.html ships no <link rel="icon"> at all — no default/placeholder
// icon on purpose, so the tab shows nothing until an admin actually
// uploads one here. This component is the only thing that ever creates
// that element, and only once a real favicon exists.
export default function SiteFavicon() {
  const faviconUrl = useSiteImage('seo.favicon', '');

  useEffect(() => {
    if (!faviconUrl) return;
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  }, [faviconUrl]);

  return null;
}
